module.exports = __webpack_public_path__ + "img/twbg_icon.b03bcfea.png";